// extracted by mini-css-extract-plugin
export default {"footer1":"footer1_footer1__PiZ05","footer1Container":"footer1_footer1Container__XTtBU","socialIcons":"footer1_socialIcons__noGOz","footerBottom":"footer1_footerBottom__3A2jr"};